import * as authActions from '../actions/auth-actions';
import * as customerActions from '../actions/customer-actions';
import * as applicationActions from '../actions/application-actions';
import * as loanActions from '../actions/loan-actions';

const initialState = {
  loan: {
    application: {
      logs: {},
      payment: {
        dueDay: null,
        method: null,
      },
      personal: {
        id: null,
        sex: null,
        name: '',
        taxId: '',
        idIssuer: '',
        idNumber: null,
        birthDate: null,
        birthState: '',
        motherName: '',
        civilStatus: null,
        idIssueDate: null,
        nationality: 55,
        emailAddress: null,
        idIssueLocality: null,
        mobilePhoneNumber: null,
        mobilePhoneBrand: null,
        bestTimeForContact: null,
        extraPhoneNumber: null,
        completed: null,
        autoFilledStatus: null,
      },
      financial: {
        property: null,
        principal: null,
        bankAccount: {
          kind: null,
          number: null,
          bankCode: null,
          checkDigit: '',
          branchNumber: null,
        },
        informedDefault: null,
        politicallyExposedPerson: null,
        insuranceRequested: false,
        completed: null,
        autoFilledStatus: null,
      },
      updatedAt: null,
      employment: {
        kind: null,
        payDay: null,
        address: '',
        employer: '',
        position: '',
        phoneNumber: null,
        monthlyIncomeRange: null,
        monthlyIncome: null,
        completed: null,
        autoFilledStatus: null,
      },
      finishedAt: null,
      cancelledAt: null,
      residential: {
        city: '',
        state: '',
        zipCode: null,
        typeName: null,
        complement: '',
        phoneNumber: null,
        neighborhood: '',
        streetAddress: '',
        streetNumber: '',
        completed: null,
        autoFilledStatus: null,
      },
      biometry: {
        submitted: false,
      },
      openFinance: {
        openFinancePartner: null,
        partnerId: null,
        consentState: 0,
        updatedAt: null,
        typeName: null
      },
      pendingInformation: [],
      pendingSteps: [],
      conditionSelectedAt: null,
      conditionsCalculatedAt: null,
      shortApplication: null,
      conditionsSelectedAt: null,
      pendingApplicationSteps: [],
    },
    state: {
      id: null,
      phase: {
        id: null,
      },
    },
    labels2: {
      multivariateTests: [],
    },
  },
  rePayments: null,
  errors: null,
  loading: [],
  questionnaire: null,
  requestCodeSuccess: null,
  checkCodeSuccess: null,
  offers: [],
};

/**
 * Loan reducer.
 * @param {*} state Current state.
 * @param {*} action Action to be perfomed.
 */
export default function personalLending(state = initialState, action) {
  let newState;
  switch (action.type) {
    // If it is a logout success action.
    case authActions.LOGOUT_SUCCESS:
      newState = { ...initialState };
      return newState;
    // If it is a login success action.
    case authActions.AUTH_LOGIN_SUCCESS:
      newState = { ...state };
      return newState;
    // If it is a find current success action.
    case customerActions.FIND_CURRENT_LOAN_SUCCESS:
      newState = {
        ...state,
        errors: null,
        loan:
          action.payload === undefined
            ? {
                ...initialState.loan,
                state: {
                  id: null,
                  phase: {
                    id: null,
                  },
                },
              }
            : action.payload,
        // loan: action.payload
      };

      return newState;
    // If it is a find current re-payments action.
    case loanActions.FIND_CURRENT_LOAN_REPAYMENTS:
      newState = {
        ...state,
        errors: null,
        loading: [...state.loading, 'loan-installments'],
      };
      return newState;
    // If it is a find current success action.
    case loanActions.FIND_CURRENT_LOAN_REPAYMENTS_SUCCESS:
      newState = {
        ...state,
        errors: null,
        rePayments: action.payload,
        loading: [...state.loading].filter((value) => value != 'loan-installments'),
      };
      return newState;
    // If it is a find current success action.
    case loanActions.FIND_CURRENT_LOAN_REPAYMENTS_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
        loading: [...state.loading].filter((value) => value != 'loan-installments'),
      };
      return newState;
    // If it is a principal select success action.
    case applicationActions.PRINCIPAL_SELECT_SUCCESS:
      newState = {
        ...state,
        errors: null,
      };
      newState.loan.application.financial.principal = action.payload;
      return newState;
    // If it is a application submit success action.
    case applicationActions.SUBMIT_NEW_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SUBMIT_NEW_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    case applicationActions.SUBMIT_NEW_LEAD_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SUBMIT_NEW_LEAD_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    case applicationActions.SUBMIT_LEAD_COMPLEMENT_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SUBMIT_LEAD_COMPLEMENT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a application submit success action.
    case applicationActions.SUBMIT_BASIC_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SUBMIT_BASIC_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a application mobile collateral consent success action.
    case applicationActions.SUBMIT_MOBILE_COLLATERAL_CONSENT_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application mobile collateral consent failure action.
    case applicationActions.SUBMIT_MOBILE_COLLATERAL_CONSENT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a application submit success action.
    case applicationActions.SUBMIT_PRE_CONTRACT_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SUBMIT_PRE_CONTRACT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a application submit success action.
    case applicationActions.SIGN_CONTRACT_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SIGN_CONTRACT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a contract extra formalization success action.
    case applicationActions.RE_CONFIRM_CONTRACT_SUCCESS:
      return {
        ...state,
        loan: action.payload == null ? initialState : action.payload,
        errors: null,
      };
    // If it is a contract extra formalization failure action.
    case applicationActions.RE_CONFIRM_CONTRACT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a cancel contract success action.
    case applicationActions.CANCEL_CONTRACT_SUCCESS:
      return {
        ...state,
        loan: action.payload == null ? initialState : action.payload,
        errors: null,
      };
    // If it is a cancel contract failure action.
    case applicationActions.CANCEL_CONTRACT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };

    // If it is a cancel contract failure action.
    case applicationActions.REQUEST_ORIGINAL_OFFER:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a calculate counter-offer success action.
    case applicationActions.REQUEST_ORIGINAL_OFFER_SUCCESS:
      return {
        ...state,
        loan: action.payload == null ? initialState : action.payload,
        errors: null,
      };
    // If it is a calculate counter-offer failure action.
    case applicationActions.REQUEST_ORIGINAL_OFFER_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a Instantor success action.
    case applicationActions.SUBMIT_INSTANTOR_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a Instantor failure action.
    case applicationActions.SUBMIT_INSTANTOR_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a Instantor success action.
    case applicationActions.SUBMIT_BANK_STATEMENT_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a Instantor failure action.
    case applicationActions.SUBMIT_BANK_STATEMENT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a application submit success action.
    case applicationActions.SUBMIT_POST_CONTRACT_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a application submit failure action.
    case applicationActions.SUBMIT_POST_CONTRACT_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };
    // If it is a code submit success action.
    case applicationActions.SUBMIT_MOBILE_COLLATERAL_CODE_SUCCESS:
      return {
        ...state,
        errors: [],
        loan: action.payload == null ? initialState.loan : action.payload,
      };
    // If it is a code submit failure action.
    case applicationActions.SUBMIT_MOBILE_COLLATERAL_CODE_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };

    case applicationActions.REQUEST_VALIDATION_CODE_SUCCESS:
      return {
        ...state,
        requestCodeSuccess: true,
        errors: [],
      };

    case applicationActions.REQUEST_VALIDATION_CODE_FAILURE:
      return {
        ...state,
        requestCodeSuccess: false,
      };

    case applicationActions.UPDATE_BANK_INFORMATION_SUCCESS:
      return {
        ...state,
      };
    case applicationActions.SUBMIT_CURRENT_LOAN_OFFER_SUCCESS:
      return {
        ...state,
        errors: null,
        loan: action.payload,
      };

    case applicationActions.SUBMIT_CURRENT_LOAN_OFFER_FAILURE:
      return {
        ...state,
        errors: action.payload,
      };

    case applicationActions.FIND_CURRENT_LOAN_OFFERS_SUCCESS:
      newState = {
        ...state,
        offers: action.payload,
      };
      return newState;

    case applicationActions.FIND_CURRENT_LOAN_OFFERS_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case applicationActions.GATHER_ADDRESS_FAILURE:
      return {...state};

    case applicationActions.SUBMIT_PSYCHROMETRIC_SUCCESS:
      newState = {
        ...state,
        errors: null,
        loan: action.payload,
      };
      return newState;

    case applicationActions.SUBMIT_PSYCHROMETRIC_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case applicationActions.SUBMIT_IDENTITY:
      return {
        ...state,
        errors: null,
        isIdentitySubmitted: false,
      };

    case applicationActions.SUBMIT_IDENTITY_SUCCESS:
      return {
        ...state,
        loan: action.payload,
        errors: null,
        isIdentitySubmitted: true,
      };

    case applicationActions.SUBMIT_IDENTITY_FAILURE:
      return {
        ...state,
        errors: action.payload,
        isIdentitySubmitted: false,
      };

    case applicationActions.FIND_MULTIPLE_LOAN_OFFERS_SUCCESS:
      newState = {
        ...state,
        offers: action.payload,
      };
      return newState;

    case applicationActions.FIND_MULTIPLE_LOAN_OFFERS_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    // If it is a counteroffer loan success action
    case applicationActions.FIND_COUNTER_OFFER_SUCCESS:
      newState = {
        ...state,
        context: action.payload,
      };
      return newState;

    // If it is a counteroffer loan failure action
    case applicationActions.FIND_COUNTER_OFFER_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return { ...state };
  }
}
